import authService from "../../services/authService";
import api from '@/services/api'
import moment from "moment";

const state = {
    status: "success",
    token: localStorage.getItem('token') || '',
    expirationTime: localStorage.getItem('expirationTime') || "",
    user: JSON.parse(localStorage.getItem('user') || '{}'),
    notification: '',
    show_notification: false,
    executing_login: false,
    executing_profile_update: false,
    open_profile: false,
    sending_reset_email: false,
    reset_email_sent: false,
    resetting_password: false,
    password_reset: false,
};

const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    expiraton_time: state => state.expirationTime,
    executing_login: state => state.executing_login,
    user: state => state.user,
    notification: state => state.notification,
    show_notification: state => state.show_notification,
    executing_profile_update: state => state.executing_profile_update,
    open_profile: state => state.open_profile,
    sending_reset_email: state => state.sending_reset_email,
    reset_email_sent: state => state.reset_email_sent,
    resetting_password: state => state.resetting_password,
    password_reset: state => state.password_reset,
};

const actions = {
    login({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            authService.login(payload)
                .then(response => {
                    commit('auth_success', response.data)
                    resolve(response)
                })
                .catch(error => {
                    commit('auth_error')
                    localStorage.removeItem('token')
                    localStorage.removeItem('expirationTime')
                    reject(error)
                })
        })
    },
    logout({commit}) {
        return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('expirationTime')
            delete api.defaults.headers.common['Authorization']
            window.$cookies.remove('sessionid')
            window.$cookies.remove('csrftoken')
            resolve()
        })
    },
    openProfile({commit}, value) {
        commit('openProfile', value)
    },
    setProfile({commit}, value) {
        commit('setProfile', value)
    },
    getProfile({commit}, id) {
        authService.fetchProfile(id)
            .then(result => {
                commit('setProfile', result)
            })
            .catch(error => {
                console.log(error)
                commit('setNotification', {text: 'Failed to get Profile Info!', type: 'error'})
            })
    },
    updateProfile({commit}, payload) {
        commit('setExecutingUpdate', true)
        let id = payload['id']
        delete payload['id']
        authService.updateProfile(id, payload)
            .then(result => {
                commit('setProfile', result)
                commit('setExecutingUpdate', false)
                commit('setNotification', {text: 'Profile Info successfully updated', type: 'success'})
                commit('setNotificationVisibility', true)
            }).catch(error => {
                console.log(error)
                commit('setExecutingUpdate', false)
                commit('setNotification', {text: 'Failed to update Profile Info!', type: 'error'})
                commit('setNotificationVisibility', true)
        })
    },
    forgotPassword({commit}, payload) {
        commit('setSendingResetEmail', true)
        authService.sendPasswordResetEmail(payload)
            .then(result => {
                console.log(result)
                commit('setSendingResetEmail', false)
                commit('setResetEmailSent', true)
            })
            .catch(error => {
                console.log(error)
                commit('setSendingResetEmail', false)
                commit('setResetEmailSent', false)
                commit('setNotification', {text: 'Failed to find an account associated with that email. Please try a different email address.', type: 'error'})
                commit('setNotificationVisibility', true)
            })
    },
    resetPassword({commit}, payload) {
        commit('setResettingPassword', true)
        authService.resetPassword(payload)
            .then(result => {
                console.log(result)
                commit('setResettingPassword', false)
                commit('setPasswordReset', true)
                commit('setNotification', {text: 'Password successfully reset', type: 'success'})
                commit('setNotificationVisibility', true)
            })
            .catch(error => {
                console.log(error)
                commit('setResettingPassword', false)
                commit('setPasswordReset', false)
                commit('setNotification', {text: 'Failed to reset password', type: 'error'})
                commit('setNotificationVisibility', true)
            })
    },

};

const mutations = {
    auth_request(state) {
        state.status = 'loading'
        state.executing_login = true
    },
    auth_success(state, data) {
        state.executing_login = false
        state.status = 'success'
        let expirationTime = moment().add(data['expires_in'], 's').format("YYYY-M-D H:m")
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data))
        localStorage.setItem('expirationTime', expirationTime)
        api.defaults.headers.common['Authorization'] = `Token ${data.token}`
        state.token = data.token
        state.expirationTime = expirationTime
        state.user = data
    },
    auth_error(state) {
        state.executing_login = false
        state.status = 'error'
    },
    logout(state) {
        state.status = ''
        state.token = ''
        state.expirationTime = null
    },
    setProfile(state, user) {
        state.user = user
        localStorage.setItem('user', JSON.stringify(user))
    },
    setNotification(state, value) {
        state.notification = value
    },
    setExecutingUpdate(state, value) {
        state.executing_profile_update = value
    },
    openProfile(state, value) {
        state.open_profile = value
    },
    setNotificationVisibility(state, value) {
        state.show_notification = value
    },
    setSendingResetEmail(state, value) {
        state.sending_reset_email = value
    },
    setResetEmailSent(state, value) {
        state.reset_email_sent = value
    },
    setResettingPassword(state, value) {
        state.resetting_password = value
    },
    setPasswordReset(state, value) {
        state.password_reset = value
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}